import { useEffect, useState } from "react";

const useAnimatedAmounts = () => {
  const [animatedAmounts, setAnimatedAmounts] = useState({});
  const [amountsList, setAmountsList] = useState([]);

  useEffect(() => {
    import("../components/SendTip/form").then((data) => {
      const getAmounts = async () => {
        const amounts = await data.getAnimatedAmounts();
        const list = await data.getAmountsList();
        setAnimatedAmounts(amounts);
        setAmountsList(list);
      };

      void getAmounts();
    });
  }, []);

  return { animatedAmounts, amountsList };
};

export default useAnimatedAmounts;
